var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgTopLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 131 297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2{fill:none;}.cls-3{fill:#ec8365;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 131,
    height: 297
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.19,21.55c-6.22,79.88-35.16,215.13-94.74,254.48-52.01,34.35-119.67,66.39-149.18,120.16-17.79,32.41-24.09,128.48-85.01,88.11-46.79-31.01-56.64-201.09-55.2-249.83,1.66-55.75,24.01-143.65,59.87-189.71C-142.66-22.54,156.91-90.08,129.19,21.55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTopLeft);
export default __webpack_public_path__ + "static/media/bg-top-left.a4d64c248d7496bce5c35c9bd0309bc1.svg";
export { ForwardRef as ReactComponent };